module.exports = __webpack_public_path__ + "img/746895.a128a0f4.jpg";